import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosVal as axios } from "..";

const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

const initialState = {
    reviews: [],
    total: 0,
    loading: false,
    success: { status: false, message: "" },
    error: { status: false, message: "" },
};

export const getPendingReviews = createAsyncThunk('reviewRequests/getPendingReviews', async (params = {}) => {
    const response = await axios.get('/mistakes', {
        params: { status: 'PENDING_REVIEW', ...params },
        headers: { 'x-auth': getToken() },
    });
    return response?.data;
});

export const approveReview = createAsyncThunk('reviewRequests/approveReview', async (id) => {
    const response = await axios.patch(`/mistakes/${id}/approve-review`, {}, {
        headers: { 'x-auth': getToken() },
    });
    return response?.data;
});

export const rejectReview = createAsyncThunk('reviewRequests/rejectReview', async ({ id, rejectReason }) => {
    const response = await axios.patch(`/mistakes/${id}/reject-review`, { rejectReason }, {
        headers: { 'x-auth': getToken() },
    });
    return response?.data;
});

const reviewRequestsSlice = createSlice({
    name: "reviewRequests",
    initialState,
    reducers: {
        resetStatus: (state) => {
            state.success.status = false;
            state.error.status = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPendingReviews.pending, (state) => {
                state.loading = true;
            })
            .addCase(getPendingReviews.fulfilled, (state, action) => {
                state.loading = false;
                const payload = action.payload;
                state.reviews = payload.data ?? payload;
                state.total = payload.total ?? 0;
            })
            .addCase(getPendingReviews.rejected, (state) => {
                state.loading = false;
            })
            .addCase(approveReview.fulfilled, (state) => {
                state.success = { status: true, message: "Review approved successfully." };
            })
            .addCase(approveReview.rejected, (state) => {
                state.error = { status: true, message: "Failed to approve review." };
            })
            .addCase(rejectReview.fulfilled, (state) => {
                state.success = { status: true, message: "Review rejected successfully." };
            })
            .addCase(rejectReview.rejected, (state) => {
                state.error = { status: true, message: "Failed to reject review." };
            });
    },
});

export const reviewRequestsActions = reviewRequestsSlice.actions;
export const reviewRequestsReducer = reviewRequestsSlice.reducer;
